import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DropdownItem } from '@models/dropdown.interface';
import { ModalModel } from '@models/modal.model';
import { NoteModel } from '@models/note.model';
import { TranslateService } from '@ngx-translate/core';
import { NoteService } from '@services/note.service';

@Component({
    selector: 'app-note',
    templateUrl: './note.component.html',
    styleUrls: ['./note.component.scss'],
})
export class NoteComponent implements OnInit {
    @Input() note: NoteModel;
    @Output() onDelete = new EventEmitter<any>();
    public noteMenu: DropdownItem[];
    public showModal: boolean = false;

    public modal: ModalModel = new ModalModel(false, '', '');
    public noteAction: 'privacity' | 'delete' | 'edit';
    public noteForm: FormGroup;
    public submitted: boolean = false;

    public isCurrentUserNote: boolean = false;

    constructor(
        private translate: TranslateService,
        private noteService: NoteService,
        private formBuilder: FormBuilder
    ) {}

    ngOnInit(): void {
        this.isCurrentUserNote = this.checkIfIsCurrentUserNote();
        this.noteForm = this.formBuilder.group({
            dealNote: ['', [Validators.required]],
        });

        this.translate
            .get('FUNNEL.dealCardNote.editNote')
            .subscribe((translated: string) => {
                this.noteMenu = [
                    {
                        key: 'edit_note',
                        icon: 'create',
                        value: translated,
                        children: [],
                    },
                    {
                        key: 'delete_note',
                        icon: 'delete',
                        value: this.translate.instant(
                            'FUNNEL.dealCardNote.deleteNote'
                        ),
                        children: [],
                    },
                ];
            });
    }

    checkIfIsCurrentUserNote(): boolean {
        return this.note.is_coordinator;
    }

    setNoteActions(action: 'privacity' | 'delete' | 'edit'): void {
        this.noteAction = action;
        this.loadModalData();
    }

    loadModalData(): void {
        this.translate
            .get('MODAL_NOTE.privacity.title')
            .subscribe((translated: string) => {
                switch (this.noteAction) {
                    case 'privacity':
                        this.modal.title = translated;
                        this.modal.text = this.translate.instant(
                            'MODAL_NOTE.privacity.message'
                        );
                        break;
                    case 'delete':
                        this.modal.title = this.translate.instant(
                            'MODAL_NOTE.delete.title'
                        );
                        this.modal.text = this.translate.instant(
                            'MODAL_NOTE.delete.message'
                        );
                        break;
                    case 'edit':
                        setTimeout(() => {
                            this.noteForm.controls['dealNoteTitle'].setValue(
                                this.note.title
                            );
                            this.noteForm.controls['dealNote'].setValue(
                                this.note.content
                            );
                        }, 100);

                        this.modal.title = this.modal.text =
                            this.translate.instant('MODAL_NOTE.edit.title');
                        this.modal.text = this.modal.text =
                            this.translate.instant('MODAL_NOTE.edit.message');
                        break;
                    default:
                        break;
                }

                this.showModal = true;
            });
    }

    manageNoteMenu(menuItem: any): void {
        this.note.toggleMenu();
        switch (menuItem.key) {
            case 'delete_note':
                this.setNoteActions('delete');
                break;
            case 'edit_note':
                this.setNoteActions('edit');
                break;
            default:
                break;
        }
    }

    managePrivacity(): void {
        if (this.note.internal) {
            this.setNoteActions('privacity');
        } else {
            this.updateNoteInternal(true);
        }
    }

    updateNoteInternal(internal: boolean) {
        this.showModal = false;
        this.noteService
            .updateNote(
                this.note.id,
                this.note.dealId,
                this.note.title,
                this.note.content,
                internal
            )
            .subscribe(
                (response) => {
                    this.note.internal = response['internal'];
                    this.submitted = false;
                },
                (error) => {
                    console.log(error);
                }
            );
    }

    updateNote(): void {
        this.submitted = true;
        if (!this.noteForm.invalid) {
            this.noteService
                .updateNote(
                    this.note.id,
                    this.note.dealId,
                    this.noteForm.value.dealNoteTitle,
                    this.noteForm.value.dealNote,
                    this.note.internal
                )
                .subscribe(
                    () => {
                        this.note.title = this.noteForm.value.dealNoteTitle;
                        this.note.content = this.noteForm.value.dealNote;
                        this.showModal = false;
                        this.submitted = false;
                    },
                    (error) => {
                        console.log(error);
                    }
                );
        }
    }

    getModalResult(event: boolean): void {
        this.showModal = false;
    }

    deleteNote(): void {
        this.noteService.deleteNote(this.note.id, this.note.dealId).subscribe(
            () => {
                this.showModal = false;
                this.onDelete.emit(true);
            },
            (error) => {
                console.log(error);
            }
        );
    }
}
